module.exports = __webpack_public_path__ + "static/media/polandTagsSmall.c5fa89c6.png";